export type MessageContextType = Record<string, unknown> & {
  severity?: 'low' | 'medium' | 'high' | 'critical' | 'blocker';
};

export interface User {
  id?: string | undefined;
  email?: string | undefined;
  name?: string | undefined;
  [key: string]: unknown;
}

export type LoggerType = {
  log: (arg: string, messageContext?: MessageContextType) => void;
  error: (arg: string, messageContext?: MessageContextType) => void;
  info: (arg: string, messageContext?: MessageContextType) => void;
  warn: (arg: string, messageContext?: MessageContextType) => void;
  debug: (arg: string, messageContext?: MessageContextType) => void;
};

export enum Scope {
  EDITOR_SDK = 'Editor SDK',
  EDITOR_CORE = 'Editor Core',
  MIMESIS_SDK = 'Mimesis SDK',
  TOUR_CAPTURE = 'Tour Capture',
  TOUR_ENGINE = 'Tour Engine',
  DESKTOP_RENDERER = 'Desktop Renderer',
}
